const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export const DATE_INPUT_SELECTOR = 'input[data-field-input]';
export const DATE_WRAP_SELECTOR = '[data-date-wrap]';
export const DATE_DISPLAY_SELECTOR = '[data-date-display]';
export const DATE_PLACEHOLDER = 'MM/DD/YYYY';

const FILLED_COLOR = '#1A1917';
const EMPTY_COLOR = '#92400E';

// Stored values are ISO (YYYY-MM-DD). A native date input shows its value in
// the browser's region format and that cannot be changed, so the editor shows
// this MM/DD/YYYY label on top of it instead.
export function isoToUsDate(iso: string | undefined): string {
  const m = ISO_DATE.exec(iso ?? '');
  return m ? `${m[2]}/${m[3]}/${m[1]}` : '';
}

export function syncDateDisplay(input: HTMLInputElement): void {
  const display = input
    .closest(DATE_WRAP_SELECTOR)
    ?.querySelector<HTMLElement>(DATE_DISPLAY_SELECTOR);
  if (!display) return;
  const shown = isoToUsDate(input.value);
  display.textContent = shown || DATE_PLACEHOLDER;
  display.style.color = shown ? FILLED_COLOR : EMPTY_COLOR;
}

// Saved paragraph text keeps a {{field}} marker where a date box was. The
// browser can hand back a non-breaking space, or no space, next to that box,
// so make sure the marker always reads as its own word.
export function normalizeSavedParagraphText(text: string): string {
  return text
    .replace(/\u00a0/g, ' ')
    .replace(/([A-Za-z0-9,;:])(\{\{[A-Za-z]+\}\})/g, '$1 $2')
    .replace(/(\{\{[A-Za-z]+\}\})(?=[A-Za-z0-9])/g, '$1 ');
}

// Attribute-safe escape; the date box is built from stored values.
const escapeAttr = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

// A native date input (for its calendar) laid invisibly over an MM/DD/YYYY label
// and a calendar icon. Both sit outside contentEditable.
export function buildDateFieldHtml(fieldKey: string, iso: string): string {
  const shown = isoToUsDate(iso);
  return (
    `<span data-date-wrap contenteditable="false" style="position:relative;display:inline-flex;` +
    `align-items:center;gap:6px;vertical-align:baseline;min-width:120px;padding:0 4px;` +
    `background:#FFFBEB;border:1px solid #FDE68A;border-radius:3px;cursor:pointer;` +
    `font-size:11px;font-family:monospace;">` +
    `<span data-date-display style="color:${shown ? FILLED_COLOR : EMPTY_COLOR};flex:1;">${escapeAttr(shown || DATE_PLACEHOLDER)}</span>` +
    `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="${FILLED_COLOR}" stroke-width="2" aria-hidden="true">` +
    `<rect x="3" y="5" width="18" height="16" rx="2"></rect><path d="M3 10h18M8 3v4M16 3v4"></path></svg>` +
    `<input type="date" data-field-input="${escapeAttr(fieldKey)}" value="${escapeAttr(iso)}" ` +
    `style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;margin:0;padding:0;border:0;cursor:pointer;" />` +
    `</span>`
  );
}
